import React, { useMemo } from "react";
import { SectionProps } from "./SectionProps";
import { Controller } from "react-hook-form";

import { CommissionModel } from "../../domain/CommissionModel";
import { Grid } from "@material-ui/core";
import { SearchField } from "@ofqual/portal-components/components/SearchField";
import { expertsService } from "../../services";
import { QueryParams } from "@ofqual/portal-core/core/types";
import { authSelector } from "../../redux/selectors";
import { useSelector } from "react-redux";

export const AssignedSpecialist: React.FC<{
  sectionProps: SectionProps<CommissionModel>;
}> = ({ sectionProps }) => {
  const {
    control,
    lookupTracker,
    editable
  } = sectionProps;
  const { token } = useSelector(authSelector);

  const readOnly: boolean | undefined = editable ? false : true;

  const expertLookupService = useMemo(
    () => ({
      get: (id: string) => expertsService.get(id, { token }),
      search: (params?: QueryParams) => { 
        let processedParams: QueryParams = {};
        if (!!params) {
          processedParams = { 
            ...params,
            approvedOnly: true,
            search: params.query
          };
        }
        
        return expertsService.search(processedParams, { token })
      }
    }),
    [token]
  );

  return (
    <Grid container spacing={3}>
      <Grid item xs={12}>
        <Controller
          control={control}
          name="assignedSpecialistId"
          as={
          <SearchField
            searchFieldVariant="single"
            label="Specialist"
            datatest="assigned-specialist-field"
            service={expertLookupService}
            disabled={false}
            readOnly={readOnly}
            lookupTracker={lookupTracker}
          />
        } />
      </Grid>
    </Grid>
  )
}